module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"pageTitle":"Afkar","pageDesc":"Afkar contains some of the ideas and projects we are excited about and always exploring.","mantra":"Projects we are |excited about."},"ar":{"pageTitle":"أفكار","pageDesc":"توى أفكار على بعض المشروعات والموضوعات التي نتحمس على الدوام من أجل اكتشافها.","mantra":"مشروعات |شغوفون بها."}}')
  delete Component.options._Ctor
}
